import Lottie from "lottie-react";
import React from "react";
import Spinner from "assets/json/spinner.json";
import { useTranslation } from "react-i18next";

const LoadMore = ({ result, requesting, initialize, loadMore, selectedTab }) => {
  const {t} = useTranslation()
  return (
    <>
      {requesting && !initialize && loadMore && selectedTab === 'milestones' && (
        <div className="flex flex-col justify-center items-center my-20">
          <Lottie animationData={Spinner} className="w-16 h-16" />
          <p className="text-md font-semibold text-gray-500">{t('loadMore')}</p>
        </div>
      )}
      {!result && !requesting && !initialize && !loadMore && selectedTab === 'milestones' && (
        <div className="flex justify-center my-10">
          <p className="text-gray-400">{t('noInformation')}</p>
        </div>
      )}
      {result && !requesting && !initialize && !loadMore && selectedTab === 'milestones' && (
        <div className="flex justify-center my-10">
          <p className="text-gray-400">{t('noMoreItemLoad')}</p>
        </div>
      )}
    </>
  );
};

export default LoadMore;
